var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .638h132.362V133H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.638)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 66.819c0 36.55-29.632 66.18-66.182 66.18C29.631 133 0 103.37 0 66.82 0 30.268 29.631.638 66.18.638c36.55 0 66.182 29.63 66.182 66.18",
    fill: "#3A913F",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.446 44.471a8.961 8.961 0 1 1-17.923-.003 8.961 8.961 0 0 1 17.923.003",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.582 44.471c0 6.682-5.416 12.096-12.098 12.096-6.679 0-12.095-5.414-12.095-12.096s5.416-12.097 12.095-12.097c6.682 0 12.098 5.415 12.098 12.097z",
    stroke: "#FFF",
    strokeWidth: 0.867
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.388 93.068l17.635-5.976-2.168-6.104s3.613-4.45 2.168-9.741c-1.447-5.292-4.336-12-4.336-12s-2.458-2.911-5.35.307c0 0-2.687-5.463-7.083-1.515 0 0-2.74-3.94-7.515-1.433l-3.325-9.56s-1.012-2.662-4.481-2.573c0 0-2.243.8-2.168 3.949l6.649 20.104s2.313 4.56-2.602.344c-4.915-4.216-7.806-1.278-7.95 0-.145 1.277.578 3.302 2.457 4.746 1.88 1.445 18.069 11.295 18.069 19.452",
    fill: "#3A913F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.388 93.068l17.635-5.976-2.168-6.104s3.613-4.45 2.168-9.741c-1.447-5.292-4.336-12-4.336-12s-2.458-2.911-5.35.307c0 0-2.687-5.463-7.083-1.515 0 0-2.74-3.94-7.515-1.433l-3.325-9.56s-1.012-2.662-4.481-2.573c0 0-2.243.8-2.168 3.949l6.649 20.104s2.313 4.56-2.602.344c-4.915-4.216-7.806-1.278-7.95 0-.145 1.277.578 3.302 2.457 4.746 1.88 1.445 18.069 11.295 18.069 19.452z",
    stroke: "#FFF",
    strokeWidth: 1.518
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.0a16ab3d0a3a01b68d2468345029bcc5.svg";
export { ForwardRef as ReactComponent };